// Visual state of a step's number badge.
export const PROCESS_STEP_STATUS = {
    DEFAULT: 'default',
    COMPLETED: 'completed',
    DONE: 'done',
};

export const PROCESS_STEP_STATUSES = new Set(Object.values(PROCESS_STEP_STATUS));
